import { render } from "./Sait-PDV.vue?vue&type=template&id=d57c46cc"
import script from "./Sait-PDV.vue?vue&type=script&lang=js"
export * from "./Sait-PDV.vue?vue&type=script&lang=js"
script.render = render

export default script